module.exports = __webpack_public_path__ + "img/search.4a46e01a.png";